<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
  >
    <el-table-column prop="service" :label="$t('servico')"></el-table-column>
    <el-table-column prop="type" :label="$t('tipo')" />
    <TableColumnButton @edit="edit" @remove="remove" />
  </el-table>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import TableColumnButton from '../components/restricted/TableColumnButton.vue';

export default {
  name: "ShippingIntegrationTable",
  props: ["tableData"],
  components: {
    TableColumnButton,
  },
  methods: {
    edit(id) {
      this.$router.replace({
        name: "shipping.edit",
        params: { id: id },
      });
    },
    remove(index) {
      console.log('index', index);
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-registro"), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        vm.$emit("remove", index);
      });
    },
  },
}
</script>